module.exports = __webpack_public_path__ + "img/custom.ec5947e4.svg";